module.exports = "/static/assets/8c72b45eaafa254580a22575fb541bc0.png";